import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import ResizeListener from "../../utility/ResizeListener";
import {
  formatBalance,
  updateClientbalance,
} from "../../utility/services/balanceServices";
import TopNavBarDropdown from "../components/TopNavBarDropdown";
import {
  Dropdown,
  NeokredNewLogo,
  Notification,
} from "../resources/assetsManager";
import { IoIosRefresh } from "react-icons/io";

import "./layout.css";
import { IoRefresh } from "react-icons/io5";
import { RupeesToPaise } from "../../utility/commaSeperator";
const Navbar = ({ balance, profileDetails }) => {
  const dispatch = useDispatch();
  const { height } = ResizeListener();
  const navigate = useNavigate();
  let location = useLocation();
  let { pathname } = { ...location };
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    dispatch(updateClientbalance());
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: height * 0.1,
        maxHeight: "100px",
        minHeight: "80px",
        borderBottom: "1px solid #E5E5E5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "sticky",
        backgroundColor: "white",
        top: 0,
        zIndex: 2,
        minWidth: "650px",
        boxSizing: "border-box",
        // overflow: "scroll",
      }}
    >
      <div
        style={{
          width: "95%",
          maxWidth: pathname === "/dashboard" ? "1260px" : "90%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "100%",
          transition: "width 0.5s ease-in-out",
          position: "relative",
          padding: pathname === "/dashboard" ? 0 : 40,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            marginRight: 20,
          }}
          onClick={() => navigate("/dashboard")}
        >
          <img
            src={NeokredNewLogo}
            style={{ objectFit: "contain", width: 180 }}
            alt="Neokred"
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            height: 80,
          }}
        >
          {/* {EmailArray.includes(profileDetails?.emailId) && (
            <div
              style={{
                width: "30%",
                height: "65%",
                minWidth: "250px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: 20,
              }}
              className="linearBorder"
              onClick={() => {
                dispatch(updateClientbalanceft());
              }}
            >
              <p style={{ fontSize: 14 }} className="roboto">
                YBL Balance:
              </p>
              <p
                style={{
                  color: "#3783fb",
                  marginLeft: 10,
                  fontWeight: "500",
                  fontSize: 18,
                }}
                className="roboto"
              >
                ₹{balance}
              </p>
            </div>
          )} */}

          {/* <div
            style={{
              width: "30%",
              height: "65%",
              minWidth: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 20,
            }}
            className="linearBorder"
          >
            <p style={{ fontSize: 14 }} className="roboto">
              Pay In:
            </p>
            <p
              style={{
                color: "#3783fb",
                marginLeft: 10,
                fontWeight: "500",
                fontSize: 18,
              }}
              className="roboto"
            >
              ₹{balance}
            </p>
          </div>
          <div
            style={{
              width: "30%",
              height: "65%",
              minWidth: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 20,
            }}
            className="linearBorder"
          >
            <p style={{ fontSize: 14 }} className="roboto">
              Pay Out:
            </p>
            <p
              style={{
                color: "#3783fb",
                marginLeft: 10,
                fontWeight: "500",
                fontSize: 18,
              }}
              className="roboto"
            >
              ₹{balance}
            </p>
          </div> */}

          <div
            style={{
              height: "65%",
              minWidth: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0px 15px",
              cursor: "pointer",
            }}
            className="linearBorder"
            title="refresh"
            onClick={() => {
              dispatch(updateClientbalance());
            }}
          >
            <p style={{ fontSize: 14 }} className="roboto">
              Pool Balance:
            </p>
            <p
              style={{
                color: "#3783fb",
                marginLeft: 10,
                fontWeight: "500",
                fontSize: 18,
              }}
              className="roboto"
            >
              ₹ {formatBalance(Number(RupeesToPaise(balance)))}
            </p>

            <IoIosRefresh
              color="#3783fb"
              style={{
                color: "#3783fb",
                margin: "0px 5px",
              }}
              size={15}
            />
          </div>
          <div
            style={{
              width: "44px",
              height: "44px",
              borderRadius: "50px",
              backgroundImage: `linear-gradient(82.62deg, #3783FB 10.19%, #CD63FF 130.33%)`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "25px",
            }}
          >
            <img
              alt="Notify"
              src={Notification}
              style={{ width: 22, height: 22 }}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: 25,
              cursor: "pointer",
              marginRight: 20,
            }}
            onClick={() => {
              if (showDropdown) setShowDropdown(false);
              else setShowDropdown(true);
            }}
          >
            <p style={{ color: "black" }} className="roboto">
              Admin
            </p>

            <img
              alt="DropDown"
              src={Dropdown}
              style={{
                marginLeft: 20,
                transform: showDropdown ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />

            {/* <IoRefresh style={{ marginLeft: 20, color: "black" }} size={20} /> */}
          </div>

          {showDropdown && (
            <div
              style={{
                backgroundColor: "white",
                width: 150,
                minHeight: 120,
                position: "absolute",
                right: pathname === "/dashboard" ? "0px" : 26,
                top: 70,
                borderRadius: 4,
                boxShadow:
                  "rgb(9 30 66 / 25%) 0px 4px 8px -2px, rgb(9 30 66 / 31%) 0px 0px 1px",
                transition: "0.5s all",
                zIndex: "1111111111111",
              }}
              onMouseLeave={() => {
                setShowDropdown(false);
              }}
              // ref={wrapperRef}
            >
              <TopNavBarDropdown
                clickHandle={() => {
                  setShowDropdown(false);
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    balance: state.BalanceReducer.clientBalance,
    profileDetails: state.profileDetailsReducer.details,
  };
};

export default connect(mapStateToProps)(Navbar);
